import { useEffect } from "react";
import { useLocale, useSetLocale } from "gt-react";
import {
  APP_LANGUAGE_LABELS,
  APP_LOCALES,
  persistLocale,
  readPreferredLocale,
  resolveAppLocale,
  type AppLocale,
} from "./i18nConfig";

export { APP_LANGUAGE_LABELS, APP_LOCALES, type AppLocale };

export function LocaleInitializer() {
  const setLocale = useSetLocale();

  useEffect(() => {
    setLocale(readPreferredLocale());
  }, [setLocale]);

  return null;
}

export function useAppLocale() {
  const locale = resolveAppLocale(useLocale());
  const setLocale = useSetLocale();

  return {
    locale,
    setLocale: (nextLocale: AppLocale) => {
      persistLocale(nextLocale);
      setLocale(nextLocale);
    },
  };
}
